import React from "react"

import { ListWrapper, ListTitle, ListItems, ListItem } from "./styles"

const List = ({ title, items }) => {
  if (!items || !items.length || !items.some(({ text }) => Boolean(text))) {
    return null
  }

  return (
    <ListWrapper>
      <ListTitle>{title}</ListTitle>
      <ListItems>
        {items.map(({ id, text }) => (
          <ListItem key={`review-list-item-${id}`}>{text}</ListItem>
        ))}
      </ListItems>
    </ListWrapper>
  )
}

export default List
